import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'pdf-icon',
  templateUrl: './pdf-icon.component.html',
  styleUrls: ['./pdf-icon.component.css']
})
export class PdfIconComponent implements OnInit {

  @Input() cssClass: string;

  constructor() { }

  ngOnInit() {
  }

}
